import React, { useState, useEffect } from 'react';
import { servicesData } from '../data/servicesData';
import './Services.css';

const Services = () => {
    const [activeService, setActiveService] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const handleServiceClick = (id) => {
        setActiveService(activeService === id ? null : id);
    };

    return (
        <div className="services-section">
            <div className="services-container">
                {/* Header */}
                <div className={`services-header ${isVisible ? 'fade-in' : ''}`}>
                    <span className="services-badge">Our Services</span>
                    <h2 className="services-title">
                        Comprehensive Visa & Immigration Solutions
                    </h2>
                    <p className="services-subtitle">
                        From initial assessment to post-visa support, we provide end-to-end assistance
                        for all your visa and immigration needs
                    </p>
                </div>

                {/* Services Grid */}
                <div className="services-grid">
                    {servicesData.map((service, index) => (
                        <div
                            key={service.id}
                            className={`service-card ${activeService === service.id ? 'active' : ''} ${isVisible ? 'slide-up' : ''}`}
                            style={{
                                animationDelay: `${index * 0.1}s`
                            }}
                            onClick={() => handleServiceClick(service.id)}
                        >
                            {/* Card Background Gradient */}
                            <div
                                className="service-card-bg"
                                style={{ background: service.color }}
                            ></div>

                            {/* Card Content */}
                            <div className="service-card-content">
                                {/* Icon */}
                                <div className="service-icon">
                                    <service.icon className="icon-component" />
                                </div>

                                {/* Title */}
                                <h3 className="service-title">{service.title}</h3>

                                {/* Description */}
                                <p className="service-description">{service.description}</p>

                                {/* Features List */}
                                <div className={`service-features ${activeService === service.id ? 'expanded' : ''}`}>
                                    <ul className="features-list">
                                        {service.features.map((feature, idx) => (
                                            <li key={idx} className="feature-item">
                                                <span className="feature-bullet">✓</span>
                                                <span className="feature-text">{feature}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                {/* Expand Button */}
                                <button className="expand-btn">
                                    {activeService === service.id ? 'Show Less' : 'Learn More'}
                                    <span className="expand-icon">
                                        {activeService === service.id ? '−' : '+'}
                                    </span>
                                </button>
                            </div>

                            {/* Hover Effect Overlay */}
                            <div className="service-card-overlay"></div>
                        </div>
                    ))}
                </div>

                {/* Call to Action */}
                <div className={`services-cta ${isVisible ? 'fade-in' : ''}`}>
                    <div className="cta-content">
                        <h3 className="cta-title">Ready to Start Your Journey?</h3>
                        <p className="cta-text">
                            Let our expert consultants guide you through every step of your visa application process
                        </p>
                        <a href="#contact" className="cta-button">
                            Get Free Consultation
                            <span className="cta-arrow">→</span>
                        </a>
                    </div>
                </div>
            </div>

            {/* Floating Background Elements */}
            <div className="services-bg-elements">
                <div className="bg-circle bg-circle-1"></div>
                <div className="bg-circle bg-circle-2"></div>
                <div className="bg-circle bg-circle-3"></div>
            </div>
        </div>
    );
};

export default Services;
